goog.provide("shadow.js.shim.module$$carbon$icons_react$es$Search$default");
shadow.js.shim.module$$carbon$icons_react$es$Search$default = shadow.js.require(370, {}).default;
